module.exports = __webpack_public_path__ + "static/img/1841_phase_function_Paper_PointsHejduk_Prediction.a85dd42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1841_phase_function_Paper_PointsHejduk_Prediction.png
// module id = fBCF
// module chunks = 0